import react, { PureComponent } from 'react';
import { isEqual } from 'lodash';

class FormikChange extends PureComponent {
    state = { values: null };

    handleChanged = ({ values, onChange }) => {
        onChange(values);
    }

    componentWillReceiveProps(nextProps) {
        const { values } = this.state;
        const newValues = nextProps.values;

        this.setState({ values: newValues });
        
        if (!isEqual(values, newValues)) {
            this.handleChanged(nextProps);
        }

    }

    render() {
        return null;
    }
}

export default FormikChange;